import PagesLayout from "../../components/global/PagesLayout";
import MainHeader from "../../components/global/MainHeader";
import Complaint from "../../components/home/Complaint";
import Partners from "../../components/home/Partners";
import Instructor from "../../components/home/Instructor";
import Description from "../../components/home/Description";
import LightboxSection from "../../components/home/LightboxSection";
import DetailsLightbox from "../../components/home/DetailsLightbox";
import Video from "../../components/home/Video";
import Takeaways from "../../components/home/Takeaways";
import Testimonials from "../../components/home/Testimonials";
import Mission from "../../components/home/Mission";
import Newsletter from "../../components/home/Newsletter";
import Contact from "../../components/home/Contact";

const Home = () => {
  return (
    <PagesLayout>
      <MainHeader />
      <Complaint />
      <Partners />
      <Instructor />
      <Description />
      <LightboxSection />
      <DetailsLightbox />
      <Video />
      <Takeaways />
      <Testimonials />
      <Mission />
      <Newsletter />
      <Contact />
    </PagesLayout>
  );
};

export default Home;
